import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { Colligate } from "../types";

export const GET_ITEM_QUERY = print(gql`
  query EducationalUnitConversion($educationalUnitConversionId: Int!) {
    EducationalUnitConversion(id: $educationalUnitConversionId) {
      id
      colligate {
        id
        databaseName
        description
        active
        partnerVisibleName
        createdAt
        updatedAt
      }
      idColligate
      databaseName
      idBranch
      educationalUnitVisibleName
      createdAt
      updatedAt
    }
  }
`);

export interface GetItemGql {
  EducationalUnitConversion: {
    id: number;
    colligate: Colligate;
    databaseName: string;
    idColligate: number;
    idArea: string;
    teachingAreaName: string;
    createdAt: Date;
    updatedAt: Date;
  };
}
